/* Native scroll-snap: no slider library, video preload or background polling. */
if (!customElements.get('lv-brand-stories')) {
  customElements.define('lv-brand-stories', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.init());
    }
    init() {
      this.track = this.querySelector('.lv-brand-films__track');
      this.slides = [...this.track.querySelectorAll('.lv-brand-film')];
      if (this.slides.length < 2) return;
      this.abort = new AbortController();
      const on = (target, event, fn, options = {}) => target.addEventListener(event, fn, { ...options, signal: this.abort.signal });
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 749px)');
      this.stopped = this.motion.matches || this.mobile.matches;
      this.index = 0;
      this.visible = false;
      this.toggle = this.querySelector('[data-story-toggle]');
      this.counter = this.querySelector('[data-story-count]');
      const progress = this.querySelector('.lv-brand-films__progress');
      progress.replaceChildren(...this.slides.map(() => {
        const part = document.createElement('span');
        part.append(document.createElement('i'));
        return part;
      }));
      this.parts = [...progress.children];
      this.querySelector('.lv-brand-films__navigation').hidden = false;
      on(this.querySelector('[data-story-prev]'), 'click', () => { this.stop(); this.go(this.index - 1); });
      on(this.querySelector('[data-story-next]'), 'click', () => { this.stop(); this.go(this.index + 1); });
      on(this.toggle, 'click', () => { this.stopped = !this.stopped; this.updateToggle(); this.schedule(); });
      on(this.track, 'keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.stop();
        this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      });
      on(this.track, 'scroll', () => {
        this.clear();
        clearTimeout(this.settle);
        this.settle = setTimeout(() => { this.sync(); this.schedule(); }, 120);
      }, { passive: true });
      on(this.track, 'pointerdown', () => { this.touching = true; this.stop(); }, { passive: true });
      for (const event of ['pointerup', 'pointercancel']) on(window, event, () => { this.touching = false; this.schedule(); }, { passive: true });
      on(this, 'pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.clear(); } });
      on(this, 'pointerleave', () => { this.hovered = false; this.schedule(); });
      on(this, 'focusin', () => this.schedule());
      on(this, 'focusout', () => queueMicrotask(() => this.schedule()));
      on(document, 'visibilitychange', () => this.schedule());
      on(this.motion, 'change', () => { if (this.motion.matches) this.stop(); });
      on(this.mobile, 'change', () => { if (this.mobile.matches) this.stop(); });
      on(this.track, 'wheel', () => this.stop(), { passive: true });
      this.querySelectorAll('video').forEach(video => {
        for (const event of ['play', 'pause', 'ended']) on(video, event, () => this.schedule());
      });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].intersectionRatio >= 0.7;
        this.schedule();
      }, { threshold: [0, 0.7, 1] });
      this.observer.observe(this.track);
      this.resize = new ResizeObserver(() => { this.track.scrollTo({ left: this.slides[this.index].offsetLeft, behavior: 'instant' }); });
      this.resize.observe(this.track);
      this.sync();
      this.updateToggle();
    }
    stop() { this.stopped = true; this.clear(); this.updateToggle(); }
    updateToggle() {
      this.toggle.setAttribute('aria-label', this.stopped ? this.toggle.dataset.play : this.toggle.dataset.pause);
      this.toggle.firstElementChild.textContent = this.stopped ? '▷' : 'Ⅱ';
    }
    clear() { clearTimeout(this.timer); this.removeAttribute('data-running'); }
    schedule() {
      this.clear();
      const focused = this.contains(document.activeElement) && document.activeElement !== this.toggle;
      if (!this.visible || document.hidden || this.mobile.matches || this.motion.matches || this.stopped || this.hovered || this.touching || focused || [...this.querySelectorAll('video')].some(v => !v.paused && !v.ended)) return;
      this.setAttribute('data-running', '');
      this.timer = setTimeout(() => this.go(this.index + 1), 8000);
    }
    go(index) {
      this.clear();
      const next = (index + this.slides.length) % this.slides.length;
      this.track.scrollTo({ left: this.slides[next].offsetLeft, behavior: this.motion.matches ? 'instant' : 'smooth' });
    }
    sync() {
      let nearest = 0;
      this.slides.forEach((slide, i) => {
        if (Math.abs(slide.offsetLeft - this.track.scrollLeft) < Math.abs(this.slides[nearest].offsetLeft - this.track.scrollLeft)) nearest = i;
      });
      this.index = nearest;
      this.counter.textContent = `${String(nearest + 1).padStart(2, '0')} / ${String(this.slides.length).padStart(2, '0')}`;
      this.parts.forEach((part, i) => part.classList.toggle('is-active', i === nearest));
      this.slides.forEach((slide, i) => {

        if (i !== nearest) slide.querySelectorAll('video').forEach(video => { if (!video.paused) video.pause(); });
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.clear();
      clearTimeout(this.settle);
      this.abort?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
    }
  });
}
